import en_agency_profile from "@/locale/en/agency_profile.json";
import en_campaign_active from "@/locale/en/campaign_active.json";
import en_campaign_application from "@/locale/en/campaign_application.json";
import en_campaign_creation from "@/locale/en/campaign_creation.json";
import en_campaign_list from "@/locale/en/campaign_list.json";
import en_campaign_overview from "@/locale/en/campaign_overview.json";
import en_campaign_preparation from "@/locale/en/campaign_preparation.json";
import en_chat from "@/locale/en/chat.json";
import en_common from "@/locale/en/common.json";
import en_company_profile from "@/locale/en/company_profile.json";
import en_customer_list from "@/locale/en/customer_list.json";
import en_errors from "@/locale/en/errors.json";
import en_influencer_discipline from "@/locale/en/influencer_discipline.json";
import en_influencer_invite from "@/locale/en/influencer_invite.json";
import en_influencer_list from "@/locale/en/influencer_list.json";
import en_influencer_profile from "@/locale/en/influencer_profile.json";
import en_invoices from "@/locale/en/invoices.json";
import en_multi_account from "@/locale/en/multi_account.json";
import en_navigation from "@/locale/en/navigation.json";
import en_notifications from "@/locale/en/notifications.json";
import en_payment_errors from "@/locale/en/payment_errors.json";
import en_payments from "@/locale/en/payments.json";
import en_verify_account from "@/locale/en/verify_account.json";
import de_agency_profile from "@/locale/ger/agency_profile.json";
import de_campaign_active from "@/locale/ger/campaign_active.json";
import de_campaign_application from "@/locale/ger/campaign_application.json";
import de_campaign_creation from "@/locale/ger/campaign_creation.json";
import de_campaign_list from "@/locale/ger/campaign_list.json";
import de_campaign_overview from "@/locale/ger/campaign_overview.json";
import de_campaign_preparation from "@/locale/ger/campaign_preparation.json";
import de_chat from "@/locale/ger/chat.json";
import de_common from "@/locale/ger/common.json";
import de_company_profile from "@/locale/ger/company_profile.json";
import de_customer_list from "@/locale/ger/customer_list.json";
import de_errors from "@/locale/ger/errors.json";
import de_influencer_discipline from "@/locale/ger/influencer_discipline.json";
import de_influencer_invite from "@/locale/ger/influencer_invite.json";
import de_influencer_list from "@/locale/ger/influencer_list.json";
import de_influencer_profile from "@/locale/ger/influencer_profile.json";
import de_invoices from "@/locale/ger/invoices.json";
import de_multi_account from "@/locale/ger/multi_account.json";
import de_navigation from "@/locale/ger/navigation.json";
import de_notifications from "@/locale/ger/notifications.json";
import de_payment_errors from "@/locale/ger/payment_errors.json";
import de_payments from "@/locale/ger/payments.json";
import de_verify_account from "@/locale/ger/verify_account.json";
import i18next, {default as i18n} from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n.use(LanguageDetector).init({
  resources: {
    en: {
      agency_profile: en_agency_profile,
      campaign_active: en_campaign_active,
      campaign_application: en_campaign_application,
      campaign_creation: en_campaign_creation,
      campaign_list: en_campaign_list,
      campaign_overview: en_campaign_overview,
      campaign_preparation: en_campaign_preparation,
      chat: en_chat,
      common: en_common,
      company_profile: en_company_profile,
      customer_list: en_customer_list,
      errors: en_errors,
      influencer_discipline: en_influencer_discipline,
      influencer_invite: en_influencer_invite,
      influencer_list: en_influencer_list,
      influencer_profile: en_influencer_profile,
      invoices: en_invoices,
      multi_account: en_multi_account,
      navigation: en_navigation,
      notifications: en_notifications,
      payment_errors: en_payment_errors,
      payments: en_payments,
      verify_account: en_verify_account,
    },
    ger: {
      agency_profile: de_agency_profile,
      campaign_active: de_campaign_active,
      campaign_application: de_campaign_application,
      campaign_creation: de_campaign_creation,
      campaign_list: de_campaign_list,
      campaign_overview: de_campaign_overview,
      campaign_preparation: de_campaign_preparation,
      chat: de_chat,
      common: de_common,
      company_profile: de_company_profile,
      customer_list: de_customer_list,
      errors: de_errors,
      influencer_discipline: de_influencer_discipline,
      influencer_invite: de_influencer_invite,
      influencer_list: de_influencer_list,
      influencer_profile: de_influencer_profile,
      invoices: de_invoices,
      multi_account: de_multi_account,
      navigation: de_navigation,
      notifications: de_notifications,
      payment_errors: de_payment_errors,
      payments: de_payments,
      verify_account: de_verify_account,
    },
  },
  fallbackLng: "ger",
  debug: false,
  ns: ["common", "verify_account"],
  defaultNS: "common",
  keySeparator: false, // we use content as keys
  interpolation: {
    escapeValue: false, // not needed for react !!
    formatSeparator: ",",
  },
  react: {
    useSuspense: false,
  },
});

// Custom formatter for forming the possessive case in translations (e.g. "XY's something")
i18n.services.formatter?.add("possessive", value => {
  const lang = i18next.resolvedLanguage;

  if (lang === "en") return value.endsWith("s") ? `${value}'` : `${value}'s`;

  return value.endsWith("s") || value.endsWith("ß") || value.endsWith("z") || value.endsWith("x")
    ? `${value}'`
    : `${value}'s`;
});

export default i18n;
